<template>
  <div>
    <div class="top-button">
      <button class="back-btn" @click="$emit('back', 'parent')">
        <div class="button-text">
          <img src="../../assets/images/back-arrow.png" alt="direction icon" />
          <div>Back</div>
        </div>
      </button>
      <button class="create-job-btn" @click="$emit('back', 'createJob')">
        <div class="button-text">
          <!-- <img
            class="job-create-icon"
            src="../../assets/images/profile-plus.svg"
            alt="Create Job icon"
          /> -->
          <div>Create a Job</div>
        </div>
      </button>
    </div>
    <div class="user-detail-container" :class="{'no-cover-photo-padding': !userDetailsData.profileUrl}">
      <div class="user-detail-content-one">
        <!-- User Cover Photo -->
        <div v-if="userDetailsData.profileUrl" class="user-cover-photo-holder">
          <img
            v-if="userDetailsData.profileUrl"
            :src="userDetailsData.profileUrl"
            alt="User profile image"
          />
          <img v-else src="../../assets/images/image-placeholder.png" alt="Placeholder image" />
        </div>

        <div class="first-name-cases">
          <p>{{ initials }}</p>
        </div>

        <!-- UserCompany Name and Type -->
        <div class="username" v-if="userDetailsData.companyName">{{ userDetailsData.companyName }}</div>
        <div class="username" v-else-if="userDetailsData.agencyName">{{ userDetailsData.agencyName }}</div>
        <div class="username" v-else>{{ userDetailsData.firstName }} {{ userDetailsData.lastName }}</div>

        <div class="type" v-if="userDetailsData.userType === 'business'">{{ userDetailsData.businessType || 'Business' }}</div>
        <div class="type" v-if="!userDetailsData.userType">{{ userDetailsData.industry || 'Agency' }}</div>
        <div class="type" v-if="userDetailsData.userType === 'normal-user'">Candidate</div>
        <!-- UserTitle and Date -->

        <!-- UserOverview -->
        <div class="overview">
          <h3>Overview</h3>
          <p v-if="userDetailsData.bio">{{ userDetailsData.bio }}</p>
          <p v-else>
            Profile not available at this time.
          </p>
        </div>
      </div>

      <!-- UserDetails-->
      <div class="user-detail-content-two">
        <div class="combined-title-text">

          <!-- UserContact Email -->
          <div class="holder">
            <p class="title">Email Address</p>
            <p class="text">
              <span v-if="userDetailsData.companyEmail">
                <a :href="`mailto:${userDetailsData.companyEmail}`" target="_blank">{{ userDetailsData.companyEmail }}</a>
              </span>
              <span v-else-if="userDetailsData.agencyEmail">
                <a :href="`mailto:${userDetailsData.agencyEmail}`" target="_blank">{{ userDetailsData.agencyEmail }}</a>
              </span>
              <span v-else-if="userDetailsData.userType === 'normal-user'">
                <a :href="`mailto:${userDetailsData.emailAddress}`" target="_blank">{{ userDetailsData.emailAddress }}</a>
              </span>
              <span v-else>
                <a :href="`mailto:${userDetailsData.emailAddress}`" target="_blank">{{ userDetailsData.emailAddress }}</a>
              </span>
            </p>
          </div>

          <!-- UserContact Number -->
          <div class="second-holder">
            <p class="title">Contact Number</p>
            <p class="text">
              <span v-if="userDetailsData.businessRepPhone">
                <a :href="`tel:${userDetailsData.businessRepPhone}`">{{ userDetailsData.businessRepPhone }}</a>
              </span>
              <span v-else-if="userDetailsData.agencyPhone">
                <a :href="`tel:${userDetailsData.agencyPhone}`">{{ userDetailsData.agencyPhone }}</a>
              </span>
              <span v-else>
                <a :href="`tel:${userDetailsData.phone}`">{{ userDetailsData.phone }}</a>
              </span>
            </p>
          </div>
        </div>

        <!-- UserCompany Contact Location -->
        <div class="combined-title-text">
          <div class="holder">
            <p class="title">Address</p>
            <p class="text">
              <span v-if="userDetailsData.businessAddress">
                {{ userDetailsData.businessAddress }}
              </span>
              <span v-else-if="userDetailsData.agencyAddress">
                {{ userDetailsData.agencyAddress }}
              </span>
              <span v-else-if="userDetailsData.address">
                {{ userDetailsData.address }}
              </span>
              <span v-else>—</span>
            </p>
          </div>

          <!-- UserCompany Website -->
          <div class="second-holder">
            <p class="title">Website URL</p>
            <span v-if="userDetailsData.websiteUrl">
              <a :href="userDetailsData.websiteUrl" target="_blank">{{ userDetailsData.websiteUrl }}</a>
            </span>
            <p class="text" v-else>—</p>
          </div>
        </div>

        <!-- UserContact Person Name for Business Users -->
        <div
          class="combined-title-text"
          v-if="userDetailsData.userType === 'business'
          || !userDetailsData.userType">
          <div class="holder">
            <p class="title">Contact Person</p>
            <p class="text">
              <span v-if="userDetailsData.firstName && userDetailsData.lastName">
                 {{ userDetailsData.firstName }} {{ userDetailsData.lastName }}
              </span>
              <span v-else>—</span>
            </p>
          </div>

          <!-- UserContact Person Phone Number -->
          <div class="second-holder">
            <p class="title">Contact Person Number</p>
            <p class="text">
              <span v-if="userDetailsData.phone">
                <a :href="`tel:${userDetailsData.phone}`">{{ userDetailsData.phone }}</a>
              </span>
              <span v-else>—</span>
            </p>
          </div>
        </div>

        <!-- User State and City -->
        <div class="combined-title-text" v-if="userDetailsData.state">
          <div class="holder">
            <p class="title">State/Province</p>
            <p class="text">
              <span v-if="userDetailsData.state">
                {{ userDetailsData.state }}
              </span>
            </p>
          </div>

          <!-- UserContact Person City-->
          <div class="second-holder" v-if="userDetailsData.city">
            <p class="title">City</p>
            <p class="text">
              <span>
                {{ userDetailsData.city }}
              </span>
            </p>
          </div>
        </div>

        <div
          class="employee-strength-holder"
          v-if="userDetailsData.userType === 'business'
          || !userDetailsData.userType"
        >
          <p>Number of Employees</p>
          <div class="employees">
            <div
              v-for="number in employeeStrength"
              v-bind:key="number.name"
              v-bind:class="{
                'active-employee-number':
                  userDetailsData.businessSize === number.range ||
                  userDetailsData.employeeStrength === number.range,
              }"
              name="employees"
            >
              <button>
                <p>{{ number.range }}</p>
                <p>Employees</p>
              </button>
            </div>
          </div>
        </div>
        <div class="action-buttons-holder">
          <button class="cancel-button" @click="deleteUserHandler">
            Delete
          </button>
          <button class="apply-button" @click="activityToggler">
            <span v-if="userDetailsData.isEnabled">Disable</span>
            <span v-else>Enable</span>
          </button>
        </div>
      </div>
    </div>
    <!-- Modal component for actions confirmation -->
    <div v-if="showModal">
      <ActionModal
        :verb="modalVerb"
        :subject="modalSubject"
        v-on:modalAction="modalAction"
      />
    </div>
  </div>
</template>

<script>
import ActionModal from '../../components/Modals/ActionModal.vue';
import { textToInitials } from '../../utils/initials';
export default {
  name: 'UserDetailsPage',
  props: ['userDetailsData'],
  components: { ActionModal },
  data() {
    return {
      showModal: false,
      modalVerb: null,
      modalSubject: null,
      optionsList: [
        { title: 'Yes', value: 'yes' },
        { title: 'No', value: 'no' },
      ],
      employeeStrength: [
        {
          name: 'a',
          range: '1 - 25'
        },
        {
          name: 'b',
          range: '26 - 50'
        },
        {
          name: 'c',
          range: '51 - 100'
        },
        {
          name: 'd',
          range: '101 - 250'
        },
        {
          name: 'e',
          range: '251 - 500'
        },
        {
          name: 'f',
          range: '500+'
        },
      ],
    };
  },
  computed: {
    displayName() {
      if (this.userDetailsData.userType === 'business') {
        return this.userDetailsData.companyName || `${this.userDetailsData.firstName} ${this.userDetailsData.lastName}`;
      }

      if (!this.userDetailsData.userType) {
        return this.userDetailsData.agencyName || `${this.userDetailsData.firstName} ${this.userDetailsData.lastName}`;
      }

      return `${this.userDetailsData.firstName} ${this.userDetailsData.lastName}`;
    },
    initials() {
      return textToInitials(this.displayName);
    },
  },
  methods: {
    activityToggler() {
      this.modalVerb = this.userDetailsData.isEnabled ? 'disable' : 'enable';
      this.modalSubject = 'user account';
      this.showModal = true;

    },
    deleteUserHandler() {
      this.modalVerb = 'delete';
      this.modalSubject = 'user account';
      this.showModal = true;
    },
    async modalAction(value) {
      //toggle modal
      this.showModal = false;
      // decide action
      if(value === 'yes') {
        switch(this.userDetailsData.userType) {
          case 'business':
            if(this.modalVerb === 'enable'){
              this.sendDispatchCall('enableUser', this.userDetailsData.id);
            }else if(this.modalVerb === 'disable'){
              this.sendDispatchCall('disableUser', this.userDetailsData.id);
            }else if(this.modalVerb === 'delete'){
              this.sendDispatchCall('deleteUser', this.userDetailsData.id);
            }else{
              this.closeModal;
            }
            break;
          case 'normal-user':
            if(this.modalVerb === 'enable'){
              this.sendDispatchCall('enableUser', this.userDetailsData.id);
            }else if(this.modalVerb === 'disable'){
              this.sendDispatchCall('disableUser', this.userDetailsData.id);
            }else if(this.modalVerb === 'delete'){
              this.sendDispatchCall('deleteUser', this.userDetailsData.id);
            }else{
              this.closeModal;
            }
            break;
          default:
            if(this.modalVerb === 'enable'){
              this.sendDispatchCall('enableUser', this.userDetailsData.id);
            }else if(this.modalVerb === 'disable'){
              this.sendDispatchCall('disableUser', this.userDetailsData.id);
            }else if(this.modalVerb === 'delete'){
              this.sendDispatchCall('deleteUser', this.userDetailsData.id);
            }else{
              this.closeModal;
            }
            break;
        }
      }
    },
    sendDispatchCall(dispatchAction, entityId) {
      this.loading = true;
      this.$store.dispatch(dispatchAction, entityId).then((res) => {
        if (res.response) {
          this.loading = false;
          this.$toastr.success(
            res.response ? res.response.message : res.response,
            'Success'
          );
          this.modalVerb === 'delete' ?
          this.$router.go() : this.userDetailsData.isEnabled = !this.userDetailsData.isEnabled;
        } else if (res.error) {
          this.loading = false;
          this.$toastr.error(
            res.error.error ? res.error.error : res.error
            ? res.error.message : res.error,
            'Failed'
          );
        }
        this.closeModal();
      });
    },
    closeModal() {
      this.showModal = false;
      this.modalVerb = null;
      this.modalSubject = null;
    }
  },
};
</script>

<style scoped>
.top-button {
  display: flex;
  justify-content: space-between;
}
.back-btn {
  font-size: 1.125rem;
  font-weight: 600;
  border: none;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
  float: left;
}
.create-job-btn {
  font-size: 1.125rem;
  font-weight: 600;
  background: var(--colorPrimary);
  border: none;
  color: var(--white);
  border-radius: 5px;
  margin-left: 30px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
  float: right;
  width: 188px;
}
.button-text {
  display: flex;
  justify-content: space-evenly;
  padding: 12px;
  align-items: center;
}
.back-btn img {
  margin-right: 10px;
}
.create-job-btn img,
.back-btn img {
  width: 30px;
}
.user-detail-container {
  background: var(--white);
  border: 0.5px solid rgba(201, 201, 201, 0.35);
  box-sizing: border-box;
  box-shadow: 0px 14px 24px rgba(9, 44, 76, 0.1);
  border-radius: 10px 10px;
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
}
.no-cover-photo-padding {
  padding-top: 2rem;
}
.user-cover-photo-holder {
  position: relative;
}
.user-detail-content-one {
  width: 50%;
}
.username {
  font-family: "montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  color: #1e88e5;
  padding-left: 30px;
  margin-bottom: 20px;
}
.type {
  font-family: "montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 33px;
  color: var(--colorSecondary);
  margin-left: 30px;
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 2px solid #dddddd;
}
.user-detail-content-two {
  width: 48%;
  margin-top: 80px;
}
.first-name-cases {
  position: relative;
  background: var(--colorPrimary);
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 30px;
  top: -60px;
}
.first-name-cases p {
  font-family: "montserrat";
  font-style: normal;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1.688rem;
  line-height: 2.057rem;
  color: var(--white);
}
.user-cover-photo-holder img {
  max-height: 450px;
  width: 100%;
  filter: drop-shadow(5px 4px 18px rgba(180, 180, 180, 0.15));
  border-radius: 15px 15px 0px 0px;
  object-fit: cover;
}
.overview {
  padding-left: 30px;
  margin-top: 30px;
  margin-bottom: 30px;
}
.overview h3 {
  font-family: "montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.6rem;
  color: var(--colorSecondary);
  margin-bottom: 20px;
}
.overview p {
  font-family: "montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 19px;
  line-height: 194.76%;
  text-align: justify;
  color: #8c8c8c;
}
.combined-title-text {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 65px;
}
.combined-title-text .holder {
  width: 50%;
}
.combined-title-text .second-holder {
  width: 50%;
}
.combined-title-text .title {
  font-family: "montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.989rem;
  color: #707070;
  margin-right: 50px;
  margin-bottom: 14px;
}
.combined-title-text .text {
  font-family: "montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 1.05rem;
  line-height: 1.809rem;
  color: var(--colorSecondary);
}
.second-title {
  margin-bottom: 50px;
}
.second-title h3 {
  font-family: "montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.628rem;
  color: var(--colorSecondary);
  margin-bottom: 13px;
}
.employee-strength-holder {
  font-family: "montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.989rem;
  color: #707070;
  margin-right: 50px;
  margin-bottom: 30px;
}
.employees > div {
  height: 147px;
  width: 48%;
  box-shadow: 0px 0px 4px 2px rgba(39, 31, 31, 0.15);
  border-radius: 5px;
  outline: none;
  font-family: "montserrat";
  font-size: 1rem;
  color: rgba(51, 52, 54, 0.7);
  line-height: 1.25rem;
  margin-top: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.employees button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.employees button p:nth-child(2) {
  margin-top: 20px;
}
.employees {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.employees > div button :nth-child(1) {
  font-style: normal;
  font-weight: 600;
  outline: none;
  font-size: 1rem;
  line-height: 29px;
  color: var(--colorSecondary);
  display: flex;
  justify-content: center;
  align-items: center;
}
.employees > div button :nth-child(2) {
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 22px;
  outline: none;
  color: #636363;
}
.active-employee-number {
  color: var(--white) !important;
  background: #025fa0 !important;
}
.active-employee-number > button p {
  color: var(--white) !important;
}

.action-buttons-holder {
  display: flex;
  justify-content: right;
  margin-top: 40px;
  margin-bottom: 80px;
  margin-right: 50px;
}
.action-buttons-holder .apply-button {
  background: var(--colorPrimary);
  font-size: 1.125rem;
  font-weight: 600;
  border: none;
  color: var(--white);
  border-radius: 5px;
  height: 53px;
  width: 188px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
}
.action-buttons-holder .cancel-button {
  background: var(--white);
  height: 53px;
  width: 188px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
  border-radius: 5px;
  font-size: 1.125rem;
  font-weight: 600;
  margin-right: 30px;
}

/* Responsive Designs */
@media only screen and (min-width: 1201px) {
  .user-detail-content-two {
    padding-left: 45px;
  }
  .user-cover-photo-holder img {
    border-radius: 15px 0px 0px 0px;
  }
}
@media only screen and (max-width: 1200px) {
  .user-detail-container {
    flex-direction: column;
  }
  .user-detail-content-one,
  .user-detail-content-two {
    width: 100%;
  }
  .name-and-location,
  .title-and-date {
    padding-left: 30px;
    padding-right: 30px;
  }
  .user-detail-content-two {
    padding: 0 30px;
  }
  .combined-title-text .second-holder,
  .combined-title-text .holder {
    width: 100%;
  }
  select {
    max-width: 100%;
  }
  .upload-file,
  .action-buttons-holder {
    width: 100%;
  }
}
</style>
